import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app.module';
import {enableProdMode, ViewEncapsulation} from '@angular/core';
import {Config} from "@synisys/idm-ui-shell/app/config";

if (process.env.NODE_ENV === "production") {
    // Production
    enableProdMode();
}

platformBrowserDynamic([
	{provide: Config.coreConfigPathToken, useValue: './app/config'},
    {provide: 'imagesPath', useValue: 'images'},
    {provide: 'configPath', useValue: './app/config'}
]).bootstrapModule(AppModule, [{defaultEncapsulation: ViewEncapsulation.None}]);
